<template>
    <b-row class="tbl-row ext-site-tbl" id="tbl-div" style="display: none">
        <b-col sm="12">
            <b-card  style="min-height: 681px;">
                <b-row class="mt-sm-2">
                    <b-col sm="12">
                        <b-row>
                            <b-col sm="12">
                              <h3 v-if="showDetailList">{{ clickedRowData['site_name'] }}</h3>
                              <h3 v-if="!showDetailList">사이트 추가</h3>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

                <!-- 우측 상단 사이트 기본 정보 form -->
                <b-row>
                  <table class="table b-table table-striped m-3">
                    <strong>사이트 기본 정보</strong>
                    <tbody>
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                        <td width="150" style="background-color:#f1f1f1" class="col-3">
                          <label class="col-form-label">사이트 ID</label>
                        </td>

                        <td v-show="!showDetailList"  class="col-3">
                          <b-row class="pt-sm-6">
                            <b-col sm="12">
                              <b-form-input id="basicText"
                                            name="site_id"
                                            type="number"
                                            v-model="extSiteFormData.site_id"
                                            v-validate="'required'"
                                            min="0"
                                            :class="{'is-invalid': errors.has('sub_title')}"
                              />
                              <span v-show="errors.has('sub_title')" :class="{error: errors.has('sub_title')}">사이트 ID는 필수 항목 입니다.</span>
                            </b-col>
                          </b-row>
                        </td>
                        <td v-show="showDetailList"  class="col-3 align-middle">
                          <b-row class="pt-sm-6">
                            <b-col sm="12">
                              <div>
                                {{extSiteFormData.site_id}}
                              </div>
                            </b-col>
                          </b-row>
                        </td>

                        <td width="150" style="background-color:#f1f1f1"  class="col-3">
                          <label class="col-form-label">사이트명</label>
                        </td>
                        <td class="col-3">
                          <b-row class="pt-sm-6">
                            <b-col sm="12">
                              <b-form-input id="basicText" name="site_name" type="text"
                                            v-model="extSiteFormData.site_name"
                                            v-validate="'required'"
                                            :class="{'is-invalid': errors.has('sub_title')}" placeholder=""/>
                              <span v-show="errors.has('sub_title')" :class="{error: errors.has('sub_title')}">사이트명은 필수 항목 입니다.</span>
                            </b-col>
                          </b-row>
                        </td>
                      </tr>

                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                        <td width="150" style="background-color:#f1f1f1">
                          <label class="col-form-label">사이트 메인 URL</label>
                        </td>
                        <td colspan="3">
                          <b-row>
                            <b-col>
                              <b-form-input id="basicText" name="main_url" type="text"
                                            v-model="extSiteFormData.main_url"
                                            v-validate="'required'"
                                            :class="{'is-invalid': errors.has('sub_title')}" placeholder=""/>
                              <span v-show="errors.has('sub_title')" :class="{error: errors.has('sub_title')}">사이트 URL은 필수 항목 입니다.</span>
                            </b-col>
                          </b-row>
                        </td>
                      </tr>

                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                        <td width="150" style="background-color:#f1f1f1">
                          <label class="col-form-label">사이트 썸네일 URL</label>
                        </td>
                        <td colspan="3">
                          <b-row>
                            <b-col>
                              <b-form-input id="basicText" name="thumb_url" type="text"
                                            v-model="extSiteFormData.thumb_url"
                                            :class="{'is-invalid': errors.has('sub_title')}" placeholder=""/>
                            </b-col>
                          </b-row>
                        </td>
                      </tr>

                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                        <td width="150" style="background-color:#f1f1f1">
                          <label class="col-form-label">사이트 SUB 썸네일 URL</label>
                        </td>
                        <td colspan="3">
                          <b-row>
                            <b-col>
                              <b-form-input id="basicText" name="sub_thumb_url" type="text"
                                            v-model="extSiteFormData.sub_thumb_url"
                                            :class="{'is-invalid': errors.has('sub_title')}" placeholder=""/>
                            </b-col>
                          </b-row>
                        </td>
                      </tr>

                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                        <td width="150" style="background-color:#f1f1f1">
                          <label class="col-form-label">수집 사이트 타입</label>
                        </td>
                        <td colspan="3">
                          <b-row>
                            <b-col>
                              <b-form-input id="basicText" name="sub_thumb_url" type="text"
                                            v-model="extSiteFormData.site_type"
                                            :class="{'is-invalid': errors.has('site_type')}" placeholder=""/>
                            </b-col>
                          </b-row>
                        </td>
                      </tr>


                    </tbody>
                  </table>
                </b-row>
              <b-row class="flex-row justify-content-center" >
                <div>
                  <button class="btn btn-primary" v-if="!showDetailList" @click="modifyExtSite('insert')">저장</button>
                  <button class="btn btn-primary" v-if="showDetailList" @click="modifyExtSite('update')">저장</button>
                  <button class="btn btn-danger" v-if="showDetailList"  @click="modifyExtSite('delete')">삭제</button>
                </div>
              </b-row>

                <!--  우측 하단 테이블   -->
                <b-row class="mt-sm-2" v-show="showDetailList">
                  <b-col sm="6">
                    <b-row>
                      <b-col>
                                <span class="">
                                    <strong>사이트 크롤링 세부 정보<br> 총 {{ totalRows | numberComma }}건</strong>
                                </span>
                      </b-col>
                      <b-col sm="6"/>
                    </b-row>
                  </b-col>
                  <b-col sm="4"/>
                  <b-col sm="2">
                    <b-form-group label-cols-sm="5" label="" class="mb-0">
                      <b-form-select
                        v-model="rowPage"
                        :options="pageOptions"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-show="showDetailList" style="min-height: 410px;">
                  <!-- 목록 -->
                  <b-col sm="12" class="pt-sm-1">
                    <b-row>
                      <b-col sm="12">
                        <b-table
                          outlined
                          hover
                          responsive
                          :fields="fields"
                          :items="items"
                          @row-clicked="onRowClicked"
                          ref="extSiteTable"
                          class="cursor-pointer"
                        >
                          <template slot="use_yn" slot-scope="row">
                            <c-switch type="text" variant="primary"
                                      v-model="row.item.use_yn"
                                      v-on:change="updateUseYn(row.item)"
                                      on="On" off="Off"
                                      :pill="true" :checked="true"/>
                          </template>
                          <template slot="main_url" slot-scope="row">
                            <div class="truncate"  @click="openModal">{{ row.item.main_url }}</div>
                          </template>
                          <template slot="sub_url" slot-scope="row">
                            <div class="truncate"  @click="openModal">{{ row.item.sub_url }}</div>
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="showDetailList">
                  <!-- 페이징 -->
                  <b-col sm="12" class="pt-sm-1">
                    <b-row class="pb-sm-2">
                      <b-col sm="12" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="rowPage"
                          :limit="limitPage"
                          @input="findExtSiteDetail"
                          align="center"></b-pagination>
                      </b-col>
                    </b-row>
                    <div style="position:absolute;top:8px; right: 20px;">
                      <button class="btn btn-secondary" v-if="showDetailList" @click="addNewExtSiteDetailClicked()">세부정보 추가</button>
                    </div>
                  </b-col>
                </b-row>

            </b-card>
          <ExtSiteDetailModal v-bind:formModal="formModal" v-bind:selectedSiteDetail="selectedSiteDetail"/>
        </b-col>
    </b-row>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import swal from 'sweetalert2'

const moment = require("moment");

import cSwitch from '../../../../components/Switch';
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../../event-bus";
import Multiselect from "vue-multiselect";
import ExtSiteDetailModal from "./ExtSiteDetailModal.vue";
import ExtReportDetailModal from "../../extReport/component/ExtReportDetailModal.vue";


Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "veeFields",
});

export default {
    name: "extSiteDetailList",
    components: {
      ExtReportDetailModal,
      ExtSiteDetailModal,
      Multiselect,
        PulseLoader,
        cSwitch,
    },
    props: {
        queryParams: {},
        fullDate: {
            type: Array,
        },
    },
    created() {
        // 사이트 추가
      EventBus.$on('callNewExtSite', ()=>{
        document.querySelector("#tbl-div").style.display = "block";
        // 전달받은 값 세팅
        this.extSiteFormData.site_id = null;
        this.extSiteFormData.site_name = null;
        this.extSiteFormData.main_url = null;
        this.extSiteFormData.thumb_url = null;
        this.extSiteFormData.sub_thumb_url = null;
        this.extSiteFormData.site_type = null;

        this.showDetailList = false;
      })
      // 사이트 선택
      EventBus.$on('callExtSiteDetail', (clickedRowData) => {
        document.querySelector("#tbl-div").style.display = "block";
        // 선택한 row 저장
        this.clickedRowData = clickedRowData;
        // 전달받은 값 복사해서 세팅
        this.extSiteFormData.site_id = clickedRowData.site_id;
        this.extSiteFormData.site_name = clickedRowData.site_name;
        this.extSiteFormData.main_url = clickedRowData.main_url;
        this.extSiteFormData.thumb_url = clickedRowData.thumb_url;
        this.extSiteFormData.sub_thumb_url = clickedRowData.sub_thumb_url;
        this.extSiteFormData.site_type = clickedRowData.site_type;
        this.showDetailList = true;
        //extsitedetail 값 조회
        this.findExtSiteDetail()
      });

      // 크롤링정보 등록/수정 후 refresh
      EventBus.$on('refreshExtSiteDetail', () => {
        this.findExtSiteDetail()
      });

      EventBus.$on('callExtSiteDetailCloseModal', () => {
        this.formModal = false;
      })

    },
    data() {
        return {
            listLoading: false,
          fields: [
            { key:'use_yn', label: "크롤링 사용", thStyle:{ width:'17%' } },
            { key:'depth_flag', label: "DEPTH", thStyle:{ width:'3%' } },
            { key:'main_url', label: "메인 URL", thStyle:{ width:'30%' } },
            { key:'sub_url', label: "세부 URL", thStyle:{ width:'50%' } },
          ],
            items: [],
            item: {},
            totalRows:0,
            currentPage: 1,
            limitPage: 8,
            rowPage: 6,
            pageOptions: [6, 10, 30],
            extSiteFormData: {
              site_id: '',
              site_name: '',
              main_url: '',
              thumb_url: '',
              sub_thumb_url: '',
              site_type: ''
            },
          clickedRowData: null,
          selectedSiteDetail: {},
          formModal: false,
          showDetailList: false
        }
    },
    mounted() {
        //this.findExtSite();
    },
  watch:{
    'rowPage'(){
      //page 옵션값 변경시 1페이지로 설정 후 리스트 get
      this.currentPage = 1;
      this.findExtSiteDetail()
    }
  },
    methods: {
        // 사이트 ID값으로 외부 리포트 site detail 정보 가져오기
        findExtSiteDetail() {
            this.queryParams.rowPage = this.rowPage;
            this.queryParams.currentPage = this.currentPage - 1;
            this.queryParams.site_id = this.extSiteFormData.site_id;

            var param = encodeURI(JSON.stringify(this.queryParams));
            var data = new FormData();
            data.append("objs", param);

            this.getList(data);
        },
        getList(data) {
            var token = sessionStorage.getItem("myToken");

            this.$http
            .post("/api/select/extSiteListDetail?access_token=" + token, data, null)
            .then((result) => {
                const { resultListCount, resultList } = result.data;
                this.totalRows = resultListCount;
                this.items = [];
                this.items = resultList;

            });
        },
      onRowClicked(item){
        this.selectedSiteDetail = item;
      },
      addNewExtSiteDetailClicked() {
        this.selectedSiteDetail = {};
        this.selectedSiteDetail.site_id = this.extSiteFormData.site_id;
        this.openModal();
      },
      openModal(){
        this.formModal = true;
      },
      updateUseYn(item) {
        let token = sessionStorage.getItem("myToken");

        let param = encodeURI(JSON.stringify(item));
        let data = new FormData();
        data.append('objs', param);

        this.$http.post('/api/update/updateExtSiteDetailUseState?access_token='+token, data, null)
          .then((result) => {
            const { data } = result;
            if(data === 'ok'){
              //해당 데이터의 sub_url과 매칭되는 값도 함께 off
              let item_sub_url = item.sub_url;
              for(let i=0; i < this.items.length; i++) {
                if (this.items[i].sub_url === item_sub_url) {
                  this.items[i].use_yn = item.use_yn;
                }
              }
            }
            else{
              swal.fire({
                type: 'error',
                title: '저장 중 오류가 발생하였습니다.',
                showConfirmButton: false,
                timer: 1500
              })
              this.findExtSiteDetail()
            }
          })


      },
      //extSite 관련 추가/수정/삭제 api 호출
      modifyExtSite(method){
        let url = '';
        let successTitle = '';

        if(method === 'insert'){
          url = '/api/insert/insertExtSite?access_token=';
          successTitle = '등록 되었습니다.'

          this.extSiteApi(url, successTitle)
        }
        else if(method === 'update'){
          url = '/api/update/updateExtSite?access_token=';
          successTitle = '수정 되었습니다.'
          this.extSiteApi(url, successTitle)
        }
        else if(method === 'delete'){
          url = '/api/delete/deleteExtSite?access_token=';
          successTitle = '삭제 되었습니다.'
          swal.fire({
            title: '사이트 삭제!',
            html: "선택하신 사이트를 삭제하시겠습니까?<br/>" +
              "해당 사이트의 크롤링 세부 정보도 함께 삭제됩니다!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          }).then((swalResult) => {
            if (swalResult.value) {
              this.extSiteApi(url, successTitle)
            }
          })
        }
      },
      extSiteApi(url, successTitle){
        let token = sessionStorage.getItem("myToken");
        let param = encodeURI(JSON.stringify(this.extSiteFormData));
        let data = new FormData();
        data.append('objs', param);

        this.$http.post(url + token, data, null)
          .then((result) => {
            const { data } = result;
            if(data == 'ok'){
              swal.fire({
                type: 'success',
                title: successTitle,
                showConfirmButton: false,
                timer: 1500
              })
            } else{
              swal.fire({
                type: 'error',
                title: '오류가 발생하였습니다.',
                showConfirmButton: false,
                timer: 1500
              })
            }
          })
          // 업데이트 성공시 detailList 숨김, 좌측 ExtSite리스트 새로고침
          .then(()=>{
            this.findExtSiteDetail()
            document.querySelector("#tbl-div").style.display = "none";
            EventBus.$emit('callFindExtSite')
          });
      }
    },
}
</script>
<style scoped>
@media(min-width: 1400px) {
  .tbl-row{width: 51%;}
}
.truncate{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 20rem;
}
.btn-secondary{
  color:white;
}
.btn-secondary:active{
  color:white !important;
}
.cursor-pointer tbody tr{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/contents/extSite/component/ExtSiteDetailList.vue